export const Markdown = {
  mounted() {
    this.handleEvent("markdown_preview", this.markdownPreview.bind(this));

    const tabs = this.el.querySelectorAll(".markdown-tab");

    tabs.forEach((el) => {
      el.addEventListener("click", (event) => {
        const tab = event.target.closest("[data-tab]");

        if (tab.dataset.tab == "preview") {
          this.el.querySelector(".markdown-preview").classList.remove("hidden");
          this.el.querySelector("textarea").classList.add("hidden");
        } else {
          this.el.querySelector(".markdown-preview").classList.add("hidden");
          this.el.querySelector("textarea").classList.remove("hidden");
        }

        this.el.querySelectorAll(".markdown-tab").forEach((el) => {
          el.classList.remove(
            "active",
            "pointer-events-none",
            "border-robe-300",
            "bg-white",
            "text-robe-400",
            "border-robe-200/70",
            "hover:text-robe-600"
          );
          if (el.dataset.tab === tab.dataset.tab) {
            el.classList.add(
              "active",
              "pointer-events-none",
              "border-robe-300",
              "bg-white"
            );
          } else {
            el.classList.add(
              "text-robe-400",
              "border-robe-200/70",
              "hover:text-robe-600"
            );
          }
        });
      });
    });

    if (this.el.querySelector("markdown-toolbar")) {
      this.el
        .querySelector("markdown-toolbar")
        .addEventListener("click", (event) => {
          const { value } = this.el.querySelector("textarea");
          this.pushEvent("markdown_update", {
            value,
          });
        });
    }
  },

  markdownPreview({ markdown }) {
    if (this.el.querySelector(".markdown-preview")) {
      this.el.querySelector(".markdown-preview").innerHTML = markdown;
    }
  },
};
